import React, { useEffect, useState, Fragment } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { numberFormat, isEmptyObject, findArrayObject, amountFormatOnly, isEmpty, getDateInStringDDMMMYYYY, numberWithCommas, numberWithCommasInput, checkNumberOnly, replaceCommas, sortByDisplay, getDisplayName, getRequestTimeInMillis } from "../../../utils/utils";
import { DialogTitle, TripActionDialogContent, DialogActions } from '../Dialog/Dialog';
import {
  TextField,
  Checkboxes,
  Radios,
  Select,
  DatePicker,
  TimePicker,
  Switches,
  Autocomplete
} from 'mui-rff';
import {
  Typography,
  Paper,
  Link,
  Grid,
  Button,
  Card,
  Dialog,
  CardActions,
  CardContent,
  CssBaseline,
  MenuItem,
  InputAdornment,
  InputLabel,
  FormControl,
  CardHeader,
  TextField as TextInput,
  Checkbox,
  Box,
  Tabs,
  Tab
} from '@material-ui/core';
// Picker
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import AmountInput from '../Inputs/AmountInput'
import { Form } from 'react-final-form';
import NotesIcon from '@material-ui/icons/Notes';
import {
  getTripDetailsV3,
  addPartyCharge,
  editPartyCharge,
  deletePartyCharge,
  addPartyAdvance,
  editPartyAdvance,
  deletePartyAdvance,
  addVendorAdvance,
  editVendorAdvance,
  deleteVendorAdvance,
  addPartyPayment,
  editPartyPayment,
  deletePartyPayment,
  addVendorPayment,
  editVendorPayment,
  deleteVendorPayment,
  addPartyExpense,
  editPartyExpense,
  deletePartyExpense,
  addPartyDeduction,
  editPartyDeduction,
  deletePartyDeduction,
  addVendorExpense,
  addExpenseV1,
  editVendorExpense,
  addVendorDeduction,
  editVendorDeduction,
  tripExpenseTypes,
  updateTrip,
  getDeductionTypes,
  getChargeTypes,
  editExpenseV1
} from "../../../store/actions/tripActionCreator";
import { getAllDrivers } from "../../../store/actions/vehicleActionCreator";
import { sendError, sendSucces } from "../../../utils/utils"
import inputStyles from '../css/inputs'
import {
  ADD_PARTY_CHARGE_SUCCESS,
  ADD_PARTY_CHARGE_FAILURE,
  ADD_VENDOR_ADVANCE_SUCCESS,
  ADD_VENDOR_ADVANCE_FAILURE,
  ADD_PARTY_ADVANCE_SUCCESS,
  ADD_PARTY_ADVANCE_FAILURE,
  ADD_VENDOR_PAYMENT_SUCCESS,
  ADD_VENDOR_PAYMENT_FAILURE,
  ADD_PARTY_PAYMENT_SUCCESS,
  ADD_PARTY_PAYMENT_FAILURE,
  ADD_PARTY_DEDUCTION_SUCCESS,
  ADD_PARTY_DEDUCTION_FAILURE,
  ADD_TRIP_EXPENS_SUCCESS,
  ADD_TRIP_EXPENS_FAILURE,
  ADD_VENDOR_DEDUCTION_SUCCESS,
  ADD_VENDOR_DEDUCTION_FAILURE,
  ADD_VENDOR_CHARGE_SUCCESS,
  UPDATE_TRIP_EXPENSE_SUCCESS,
  UPDATE_PARTY_CHARGE_SUCCESS,
  UPDATE_PARTY_REDUCTION_SUCCESS,
  UPDATE_PARTY_ADVANCE_SUCCESS,
  UPDATE_PARTY_PAYMENT_SUCCESS,
  UPDATE_VENDOR_CHARGE_SUCCESS,
  UPDATE_VENDOR_DEDUCTION_SUCCESS,
  UPDATE_VENDOR_ADVANCE_SUCCESS,
  UPDATE_VENDOR_PAYMENT_SUCCESS
} from "../../../store/constants";
import { trackDwebEvent } from '../../analytics';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import AddExpenseType from './AddExpenseType';
import AddDriver from '../AddDialogComponent/AddDialogComponent';
import addStyles from '../css/addEditTrip';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { AddPersonIcon } from '../../../components/icons';
import DriverSelect from '../../components/Driver/DriverSelect';
import { OnChange } from 'react-final-form-listeners';
import { data } from 'jquery';
import * as logger from '../../../logger';
import AddChargeDeductionType from './AddChargeDeductionType';
import EventOutlinedIcon from '@material-ui/icons/EventOutlined';
import { shopListForSelection } from '../../../store/actions/userActionCreators';
import { defaultPageNo, defaultPageSize, defaultDebounceMs } from '../../../paginationVariables';
import { debounce } from 'lodash';
import { Waypoint } from "react-waypoint";
import AddShop from '../../pages/Shops/AddShop';
import AddFuelExpenseDialog from "../VehicleDialogs/AddFuelExpenseDialog";

const expenseTypefilter = createFilterOptions({
  limit: 30
});
const filter = createFilterOptions({
  limit: 20,
  matchFrom: 'any'
});
const useStyles = makeStyles(theme => ({
  formRoot: {
    '& .MuiFormControl-root': {
      width: '100%',
      margin: '16px 0px'
    }
  },
  listBoxV1: {
    paddingTop: '0px !important',
    paddingBottom: '0px !important'
  },
  dialogContent: {
    padding: '16px 24px'
  },
  switchLabel: {
    marginLeft: 0
  },
  switchControl: {
    marginTop: 16,
    marginBottom: 8
  },
  eventIcon: {
    color: 'grey'
  },
  error: {
    color: 'red',
    marginBottom: 8
  },
  expenseTypeListItem: {
    padding: '12px 15px',
    minHeight: 46,
    margin: 0,
    maxHeight: 46,
    width: '100%'
  },
  addExpenseListItem: {
    padding: '12px 15px',
    margin: 0,
    backgroundColor: '#0b1323',
    color: '#fff',
    fontWeight: 300,
    minHeight: 46,
    width: '100%',
    maxHeight: 46
  },
  addExpenseIcon: {
    color: '#fff',
    marginRight: 10
  },
  cherveRightIcon: {
    marginLeft: 10,
    float: 'right',
    color: '#fff'
  },
  cherveRightIconV1: {
    marginLeft: 10,
    float: 'right',
    color: '#5170f0'
  },
  listBoxAutoCompelete: {
    margin: 0,
    padding: 0
  },
  listBoxOption: {
    padding: 0,
    minHeight: 46,
    maxHeight: 46,
    borderBottom: '1px solid #eaedf3',
    "&:first-child": {
    },
    "&:last-child": {
    }
  },
  popUpIndicator: {
    display: 'none'
  },
  divTripV2: {
    fontSize: 16,
    fontWeight: 300,
    marginTop: 6
  },
  billingTypeRadio: {
    maxWidth: '100% !important',
    marginTop: 16,
    '& .MuiFormControl-fullWidth': {
      //maxWidth:'100% !important'
    },
    '& .MuiFormControlLabel-root': {
      //marginRight:0
    },
    '& .MuiRadio-root': {
      //display:'none'
    },
    '& .MuiFormLabel-root': {
      fontSize: 12,
      letterSpacing: '0.05em',
      marginBottom: 12,
    }
  },
  billingTypeLabel: {
    //height: 36,
    //padding: '6px 12px',
    borderRadius: 16,
    marginRight: 6,
    marginLeft: 0,
    backgroundColor: '#e4e4e4',
    '& .MuiButtonBase-root': {
      display: 'none'
    },
    '& .MuiTypography-root': {
      fontSize: 14,
      padding: '8px 12px',
      borderRadius: 16,
      backgroundColor: '#e4e4e4',
      color: '#6b778c',
      fontWeight: 300,
    },
    '& span.Mui-checked+span': {
      color: '#0033cc',
      fontWeight: 300,
      backgroundColor: '#d1ddff',
      border: '1px solid #0033cc',
      paddingTop: 7,
      paddingBottom: 7,
      paddingLeft: 11,
      paddingRight: 11,
      fontSize: 14,
    }
  },
  mtV2: {
    marginTop: 16
  },
  shopOption: {
    paddingLeft: 0,
    paddingRight: 0,
    borderBottom: '1px solid #eaedf3',
    paddingTop: 0,
    paddingBottom: 0
  },
  shopListItem: {
    padding: '12px 15px',
    minHeight: 46,
    margin: 0,
    // maxHeight: 46,
    width: '100%',
    //borderBottom:"1px solid #eaedf3"
  },
  shopListItem1: {
    padding: '12px 15px',
    minHeight: 46,
    margin: 0,
    maxHeight: 46,
    width: '100%',
    color: "#5170f0",
    backgroundColor: '#E3E8FD'
  },
  titleBullet: {
    borderRadius: "50%",
    backgroundColor: "lightgrey",
    fontSize: 8,
    color: "lightgrey",
    margin: "0px 6px",
    marginTop: -2
  },
  addPersonIcon: {
    color: '#0033cc',
    marginRight: 10
  },
  disableCta: {
    padding: '9px 26px 11px 28px',
    borderRadius: 4,
    boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.1)',
    backgroundColor: '#efeff2',
    fontSize: 14,
    fontWeight: 'bold',
    color: '#3e3f42',
    height: 36,
    textTransform: 'capitalize',
    letterSpacing: '0.02em'
  },
  saveCta: {
    padding: '9px 26px 11px 28px',
    borderRadius: 4,
    boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.1)',
    backgroundColor: '#09101e',
    fontSize: 14,
    fontWeight: 300,
    color: 'white',
    height: 36,
    textTransform: 'capitalize',
    letterSpacing: '0.02em',
    '&:hover': {
      backgroundColor: '#09101e',
    }
  },
  autoCompletePaper: {
    marginBottom: '14px !important'
  }
}));
const normalizeAmount = value => {
  if (!value) return value;
  const onlyNums = value.replace(/[^\d]/g, "");
  if (onlyNums.length > 0) return amountFormatOnly(Number(onlyNums));
};
const TransportBookTabs = withStyles({
  root: {
    borderBottom: '0px solid #e8e8e8',
  },
  indicator: {
    backgroundColor: '#0033cc',
    height: 4,
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4
  },
})(Tabs);
function TabPanel(props) {
  const { children, value, component, index, ...other } = props;
  let ComponentFromProp = component;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`nav-tabpanel-${index}`}
      aria-labelledby={`nav-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `nav-tab-${index}`,
    'aria-controls': `nav-tabpanel-${index}`,
  };
}

function LinkTab(props) {
  return (
    <Tab
      component="a"
      onClick={(event) => {
        event.preventDefault();
      }}
      {...props}
    />
  );
}

const AntTab = withStyles((theme) => ({
  root: {
    textTransform: 'none',
    minWidth: 72,
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: theme.spacing(4),
    '&:hover': {
      color: '#40a9ff',
      opacity: 1,
    },
    '&$selected': {
      color: '#0033cc',
      fontWeight: theme.typography.fontWeightMedium,
    },
    '&:focus': {
      color: '#0033cc',
    },
  },
  selected: {},
}))((props) => <Tab disableRipple {...props} />);
const TripActionDialog = (props) => {
  const formClasses = useStyles();
  const inputClasses = inputStyles();
  const autoClasses = addStyles();
  let submit;
  let formValues;
  const {
    user,
    onConfirm,
    classes,
    open,
    onClose,
    onSave,
    action,
    defaultSelected,
    defaultPerson,
    defaultAmount,
    location,
    dispatchAddPartyChargeAction,
    dispatchAddPartyAdvanceAction,
    dispatchAddVendorAdvanceAction,
    dispatchAddPartyPaymentAction,
    dispatchAddVendorPaymentAction,
    dispatchAddPartyExpenseAction,
    dispatchAddPartyDeductionAction,
    dispatchAddVendorExpense,
    dispatchAddVendorDeduction,
    editData,
    onUpdateSuccess,
    confirmText,
    dispatchEditVendorExpense,
    dispatchEditPartyCharges,
    dispatchEditPartyDeductionAction,
    dispatchEditPartyAdvance,
    dispatchEditPartyPayment,
    dispatchEditVendorDeduction,
    dispatchEditVendorAdvance,
    dispatchEditVendorPayment,
    dispatchGetTripExpenseTypes,
    trip,
    partyBalance,
    vendorBalance,
    dispatchGetAllDrivers,
    dispatchUpdateTrip,
    vehicle,
    dispatchTripDetailsAction,
    dispatchGetCharges,
    dispatchGetDeductions,
    dispatchGetShopList,
    dispatchAddExpenseV1,
    dispatchEditExpenseV1,
    ...other
  } = props;
  let path = location && location.pathname ? location.pathname.split("/") : [];
  let tripDetails = user.singleTripData ? user.singleTripData : {};
  let tripId = tripDetails && tripDetails.id ? tripDetails.id : path[path.length - 1];
  let vehicleId = tripDetails && tripDetails.vehicle && tripDetails.vehicle.id ? tripDetails.vehicle.id : null;
  let hiredTrip = tripDetails && tripDetails.vehicle && tripDetails.vehicle.ownershipType && tripDetails.vehicle.ownershipType == 'HIRED' ? true : false;
  let vendorId = hiredTrip && tripDetails && tripDetails.vendor && tripDetails.vendor.id ? tripDetails.vendor.id : 0;
  let fleetOwnerId = user.userInfo.entityId;
  let tripStatus = tripDetails && tripDetails.status ? tripDetails.status : '';
  let driverVal = tripDetails && tripDetails.driver && tripDetails.driver.id ? tripDetails.driver.id : null;
  let vendorSettled = tripDetails && !isEmpty(tripDetails.isVendorSettled) ? tripDetails.isVendorSettled : tripDetails && tripDetails.vendorBalance && Number(tripDetails.vendorBalance) == 0 ? true : false;
  let actionVisible = () => {
    if (hiredTrip) {
      return (tripStatus == 'PAYMENT_RECEIVED' && vendorSettled) ? false : true
    } else {
      return (tripStatus == 'PAYMENT_RECEIVED') ? false : true
    }
  }
  const trackTransactions = (name, id) => {
    trackDwebEvent(name, {
      trip_id: tripId,
      party_id: user.singleTripData.party && user.singleTripData.party.customerId,
      party_name: user.singleTripData.party && user.singleTripData.party.name,
      vehicle_id: user.singleTripData.vehicle && user.singleTripData.vehicle.id,
      vehicle_number: user.singleTripData.vehicle && user.singleTripData.vehicle.number,
      trip_status: user.singleTripData.status,
      vendor_id: id ? id : null
    });
  }

  const addFuelExpenseData = {
    vehicleId: user && user.singleTripData && user.singleTripData.vehicle && user.singleTripData.vehicle.id ? user.singleTripData.vehicle.id : "",
    driverId: user && user.singleTripData && user.singleTripData.vehicle && user.singleTripData.vehicle.driverId ? user.singleTripData.vehicle.driverId : "",
    driverName: user && user.singleTripData && user.singleTripData.vehicle && user.singleTripData.vehicle.driverName ? user.singleTripData.vehicle.driverName : "",
    tripId: user && user.singleTripData && user.singleTripData.id ? user.singleTripData.id : ""
  }

  const [dialogopen, setDialogOpen] = React.useState(open);
  const [formError, setFormError] = React.useState(false);
  const [check, setCheck] = React.useState(false);
  const [value, setValue] = React.useState(defaultSelected ? defaultSelected : (hiredTrip && tripStatus == 'PAYMENT_RECEIVED' && !vendorSettled) ? 1 : 0);
  const [person, setPerson] = React.useState(defaultPerson ? defaultPerson : (hiredTrip && tripStatus == 'PAYMENT_RECEIVED' && !vendorSettled) ? 'supplier' : action && action.tabs && action.tabs[0] && action.tabs[0].person ? action.tabs[0].person : 'party');
  const [expenseType, setExpenseType] = React.useState(null);
  const [expenseDate, setExpenseDate] = React.useState(new Date());
  const [expenseAmount, setExpenseAmount] = React.useState('');
  const [expenseNotes, setExpenseNotes] = React.useState('');
  const [expensePaidByDriver, setExpensePaidByDriver] = React.useState(false);
  const [expenseAddToPartyBill, setExpenseAddToPartyBill] = React.useState(false);
  const [expenseBillableAmount, setExpenseBillableAmount] = React.useState('');
  const [expenseTransactionId, setExpenseTransactionId] = React.useState('');
  const [expensePaymentMethod, setExpensePaymentMethod] = React.useState('cash');
  const [selectedExpenseDriver, setSelectedExpenseDriver] = React.useState(tripDetails && tripDetails.driver && tripDetails.driver.name ? tripDetails.driver.name : null)
  const [shopsListData, setShopsListData] = React.useState(null);
  const [shops, setShops] = React.useState([]);
  const [expenseShop, setExpenseShop] = React.useState(null);
  const [shopInputValue, setShopInputValue] = React.useState('');
  const [currentPageNo, setCurrentPageNo] = useState(1);
  const [currentPageSize, setCurrentPageSize] = useState(10);
  const [newExpenseType, setNewExpenseType] = React.useState({
    name: ''
  })
  const [newExpenseOpen, setNewExpenseOpen] = React.useState(false);
  const [newExpenseShop, setNewExpenseShop] = React.useState({
    name: ''
  })
  const [addShopOpen, toggleAddShopOpen] = React.useState(false);
  const [shopDialogValue, setShopDialogValue] = React.useState({
    name: ''
  });
  const [addFuelExpenseOpen, setAddFuelExpenseOpen] = useState(false);

  const handleAddShopClose = () => {
    setShopDialogValue({
      name: '',
    });
    toggleAddShopOpen(false);
  };
  const handleShopSave = (status, response) => {
    toggleAddShopOpen(false);
    fetchShops()
    setExpenseShop(response && response.id ? response : null);
  }
  const [newExpenseShopOpen, setNewExpenseShopOpen] = React.useState(false);
  /*let initialValues ={
    ...initialValues,
    ...editData,
    date:editData.paymentDate && Number(editData.paymentDate) ==0?new Date():new Date(Number(editData.paymentDate)*1000),
    payment_mode:editData.paymentMode?editData.paymentMode:'Cash',
    notes:editData.description?editData.description:'',
    amount:editData.totalAmount?numberWithCommas(Math.abs(editData.totalAmount)):'',
    refNumber:editData.paymentData?editData.paymentData:'',
    receivedByDriver:editData.receivedByDriver?editData.receivedByDriver:false
  }*/
  //add/Edit AdvancePayment
  const [paymentAdvanceDate, setPaymentAdvanceDate] = React.useState(new Date());
  const [paymentAdvanceMode, setPaymentAdvanceMode] = React.useState('Cash');
  const [paymentAdvanceNotes, setPaymentAdvanceNotes] = React.useState(null);
  const [paymentAdvanceAmount, setPaymentAdvanceAmount] = React.useState(defaultAmount ? numberWithCommas(defaultAmount) : null);
  const [paymentAdvanceRefNum, setPaymentAdvanceRefNum] = React.useState(null);
  const [paymentAdvanceReceivedByDriver, setPaymentAdvanceReceivedByDriver] = React.useState(null);

  const [chargeOrDeductionBillingType, setChargeOrDeductionBillingType] = React.useState("add_to_bill");
  const [chargeOrDeductionType, setChargeOrDeductionType] = React.useState({});
  const [chargeOrDeductionAmount, setChargeOrDeductionAmount] = React.useState(null);
  const [chargeOrDeductionDate, setChargeOrDeductionDate] = React.useState(new Date());
  const [chargeOrDeductionNotes, setChargeOrDeductionNotes] = React.useState(null);
  const [chargeTypeList, setChargeTypeList] = useState([]);
  const [deductionTypeList, setDeductionTypeList] = useState([]);
  const [checkType, setCheckType] = useState("");
  const [addChargeDeduction, setAddChargeDeduction] = useState(false);
  const [deductionCheck, setDeductionCheck] = useState(false);

  const fetchTrip = (tripId) => {
    dispatchTripDetailsAction(tripId, () => {
    });
  }
  const [driverNameModalOpen, setDriverNameModalOpen] = React.useState(false);
  const handleDriverSelectClose = () => {
    setDriverNameModalOpen(false);
    setExpensePaidByDriver(false);
    setExpensePaymentMethod('cash')
    setPaymentAdvanceReceivedByDriver(false);
    setCheck(true);
  };
  const handleDriverSelectOpen = () => {
    setDriverNameModalOpen(true);
    setCheck(false);
  };
  const handleDriverSelectConfirm = (response) => {
    if (response && response.id) {
      dispatchUpdateTrip(tripId, { driverId: response.id }, (data) => {
        if (data && data.status && data.status.code && data.status.code === 200) {
          setCheck(false);
          fetchTrip(tripId);
          setSelectedExpenseDriver(data && data.response && data.response.driverName ? data.response.driverName : '')
          setDriverNameModalOpen(false);
          setExpensePaymentMethod('paid_by_driver');
        }
      }, () => {

      })
    }
  }

  useEffect(() => {
    if (action && action.action == 'add_charges') {
      setChargeOrDeductionType({});
    }
  }, [deductionCheck])

  useEffect(() => {

    if (trip && trip.tripChargeType) {
      setChargeTypeList(trip.tripChargeType);
    }

    if (trip && trip.tripDeductionType) {
      setDeductionTypeList(trip.tripDeductionType);
    }

  }, [trip.tripDeductionType, trip.tripChargeType]);

  useEffect(() => {

    if (action && (action.action == 'add_charges' || action.action == 'edit_party_charge' || action.action == 'edit_vendor_charge' || action.action == 'edit_vendor_reduction' || action.action == 'edit_party_reduction')) {
      dispatchGetCharges(
        (data) => {
          if (data && data.status && data.status.code && data.status.code == 200) {
            logger.log('Trip Action Dialog Dweb', 'Get Trip Charges Successfull');
            dispatchGetDeductions(
              (data) => {
                if (data && data.status && data.status.code && data.status.code == 200) {
                  logger.log('Trip Action Dialog Dweb', 'Get Trip Deductions Successfull');
                }
              },
              () => {
                logger.log('Trip Action Dialog Dweb', 'Get Trip Deductions Failed');
              }
            )
          }
        },
        () => {
          logger.log('Trip Action Dialog Dweb', 'Get Trip Charges Failed');
        }
      )
    }

    if (action && (action.action == 'add_expense')) {
      dispatchGetTripExpenseTypes(
        () => {

        }, () => {
        });
    }
    if (action && (action.action == 'edit_expense')) {
      let expenseDateState = editData && editData.expenseDate ? new Date(Number(editData.expenseDate) * 1000) : new Date();
      let expenseTypesState = editData && editData.expenseType && trip && trip.tripExpenseTypes ? trip.tripExpenseTypes.find(o => o.value === editData.expenseType) : null;
      let expenseAmountState = editData && editData.amount ? numberWithCommas(Number(editData.amount)) : '';
      let expenseNotesState = editData && editData.description ? editData.description : '';
      let expensePaidByDriverState = editData && editData.paidByDriver ? editData.paidByDriver : false;
      if (editData.paymentMethod) {
        setExpensePaymentMethod(editData.paymentMethod);
      }
      if (editData.paymentData) {
        setExpenseTransactionId(editData.paymentData)
      }
      setExpenseType(expenseTypesState);
      setExpenseDate(expenseDateState);
      setExpenseAmount(expenseAmountState);
      setExpenseNotes(expenseNotesState);
      setExpensePaidByDriver(expensePaidByDriverState);
    }
    if (!defaultAmount && action.action == 'add_payment') {
      if (person && person == 'party' && partyBalance) {
        setPaymentAdvanceAmount(numberWithCommas(partyBalance))
      }
      if (person && person == 'supplier' && vendorBalance) {
        setPaymentAdvanceAmount(numberWithCommas(vendorBalance))
      }
    }
    if (action && (action.action == 'edit_party_advance' || action.action == 'edit_party_payment')) {
      let date = editData.dateDirect ? editData.dateDirect : editData.paymentDate && Number(editData.paymentDate) == 0 ? new Date() : new Date(Number(editData.paymentDate) * 1000);
      let payment_mode = editData.paymentMode ? editData.paymentMode : 'Cash';
      let notes = editData.description ? editData.description : '';
      let amount = editData.totalAmount ? numberWithCommas(Math.abs(editData.totalAmount)) : editData.amount ? numberWithCommas(Math.abs(editData.amount)) : null;
      let refNumber = editData.paymentData ? editData.paymentData : null;
      let receivedByDriver = editData.receivedByDriver ? editData.receivedByDriver : false;
      setPaymentAdvanceDate(date);
      setPaymentAdvanceMode(payment_mode);
      setPaymentAdvanceNotes(notes);
      setPaymentAdvanceAmount(amount);
      setPaymentAdvanceRefNum(refNumber);
      setPaymentAdvanceReceivedByDriver(receivedByDriver);

    }
    if (action && (action.action == 'edit_vendor_advance' || action.action == 'edit_vendor_payment')) {
      let date = editData.paymentDate && Number(editData.paymentDate) == 0 ? new Date() : new Date(Number(editData.paymentDate) * 1000);
      let payment_mode = editData.paymentMode ? editData.paymentMode : 'Cash';
      let notes = editData.description ? editData.description : null;
      let amount = editData.amount ? numberWithCommas(Math.abs(editData.amount)) : null;
      let refNumber = editData.paymentData ? editData.paymentData : null;
      setPaymentAdvanceDate(date);
      setPaymentAdvanceMode(payment_mode);
      setPaymentAdvanceNotes(notes);
      setPaymentAdvanceAmount(amount);
      setPaymentAdvanceRefNum(refNumber);
    }
    if (action && (action.action == 'edit_party_charge')) {
      let transactionDate = editData.expenseDate && Number(editData.expenseDate) == 0 ? new Date() : new Date(Number(editData.expenseDate) * 1000);
      let billing_type = 'add_to_bill';
      let chargeOrDeduction_type = editData.transactionType ? editData.transactionType : '';
      let chargeOrDeduction_type_display = editData.displayName ? editData.displayName : ""
      let notes = editData.description ? editData.description : '';
      let amount = editData.totalAmount ? numberWithCommas(Number(editData.totalAmount)) : '';
      setChargeOrDeductionDate(transactionDate);
      setChargeOrDeductionBillingType(billing_type);
      setChargeOrDeductionNotes(notes);
      setChargeOrDeductionType({
        display: chargeOrDeduction_type_display,
        value: chargeOrDeduction_type
      });
      setChargeOrDeductionAmount(amount);
    }
    if (action && (action.action == 'edit_vendor_charge')) {
      let transactionDate = editData.expenseDate && Number(editData.expenseDate) == 0 ? new Date() : new Date(Number(editData.expenseDate) * 1000);
      let billing_type = 'add_to_bill';
      let chargeOrDeduction_type = editData.type ? editData.type : '';
      let chargeOrDeduction_type_display = editData.displayName ? editData.displayName : '';
      let notes = editData.description ? editData.description : '';
      let amount = editData.amount ? numberWithCommas(Math.round(editData.amount)) : '';
      setChargeOrDeductionDate(transactionDate);
      setChargeOrDeductionBillingType(billing_type);
      setChargeOrDeductionNotes(notes);
      setChargeOrDeductionType({
        display: chargeOrDeduction_type_display,
        value: chargeOrDeduction_type
      });
      setChargeOrDeductionAmount(amount);
    }
    if (action && (action.action == 'edit_vendor_reduction')) {
      let transactionDate = editData.expenseDate && Number(editData.expenseDate) == 0 ? new Date() : new Date(Number(editData.expenseDate) * 1000);
      let billing_type = 'reduce_from_bill';
      let chargeOrDeduction_type = editData.type ? editData.type : '';
      let chargeOrDeduction_type_display = editData.displayName ? editData.displayName : '';
      let notes = editData.description ? editData.description : '';
      let amount = editData.amount ? numberWithCommas(Math.abs(editData.amount)) : '';
      setChargeOrDeductionDate(transactionDate);
      setChargeOrDeductionBillingType(billing_type);
      setChargeOrDeductionNotes(notes);
      setChargeOrDeductionType({
        display: chargeOrDeduction_type_display,
        value: chargeOrDeduction_type
      });
      setChargeOrDeductionAmount(amount);
    }
    if (action && (action.action == 'edit_party_reduction')) {
      let transactionDate = editData.expenseDate && Number(editData.expenseDate) == 0 ? new Date() : new Date(Number(editData.expenseDate) * 1000);
      let billing_type = 'reduce_from_bill';
      let chargeOrDeduction_type = editData.transactionType ? editData.transactionType : '';
      let chargeOrDeduction_type_display = editData.displayName ? editData.displayName : ""
      let notes = editData.description ? editData.description : '';
      let amount = editData.totalAmount ? numberWithCommas(Math.abs(editData.totalAmount)) : '';
      setChargeOrDeductionDate(transactionDate);
      setChargeOrDeductionBillingType(billing_type);
      setChargeOrDeductionNotes(notes);
      setChargeOrDeductionType({
        display: chargeOrDeduction_type_display,
        value: chargeOrDeduction_type
      });
      setChargeOrDeductionAmount(amount);
    }
  }, [dialogopen]);
  const onSearchBlur = debounce(query => {
    setCurrentPageNo(defaultPageNo)
    fetchShops(query, false)
  }, user && user.configs && user.configs.dwebSearchBebounceMs ? parseInt(user.configs.dwebSearchBebounceMs) : defaultDebounceMs);
  const fetchShops = (search, pagination) => {
    let req = {
      pageSize: defaultPageSize,
      pageNo: defaultPageNo,
    }
    if (pagination) {
      req.pageNo = currentPageNo + 1
    }
    if (search) {
      req.search = search;
    }
    dispatchGetShopList(req, (res) => {
      if (res && res.status && res.status.code && res.status.code == 200 && res.response) {
        setShopsListData(res.response)
        if (pagination) {
          setShops([...shops, ...res.response.shops])
        } else {
          setShops(res.response.shops)
        }
      }
    }, () => {

    })
  }
  useEffect(() => {
    let active = true;
    if (shopInputValue === '') {
      return undefined;
    }
    return () => {
      active = false
    }
  }, [shopInputValue])
  useEffect(() => {
    if (expensePaymentMethod && expensePaymentMethod == 'credit') {
      //fetchShops()
    }
    if (expensePaymentMethod && expensePaymentMethod == 'paid_by_driver') {
      if (!driverVal) {
        handleDriverSelectOpen(true);
      }
      if (driverVal && tripDetails && tripDetails.driver && tripDetails.driver.name) {
        setSelectedExpenseDriver(tripDetails.driver.name)
      }
    }
  }, [expensePaymentMethod])
  const handleAddExpenseTypeClose = () => {
    setNewExpenseOpen(false);
    setNewExpenseType({
      name: ''
    })
  }

  const handleAddExpenseTypeSave = (status, response) => {
    setNewExpenseOpen(false);
    setNewExpenseType({
      name: ''
    });
    setExpenseType(response);
  }
  const validate = values => {
    const errors = {};
    if (values) {
      if (errors.noValues) {
        delete errors['noValues'];
      }
      if (action &&
        (action.action == 'add_charges' || action.action == 'edit_party_reduction'
          || action.action == 'edit_party_charge'
          || action.action == 'edit_vendor_charge'
          || action.action == 'edit_vendor_reduction'
        )
      ) {
        if (!values.chargeOrDeduction_type) {
          errors.chargeOrDeduction_type = 'Please Select a Type';
        }
        if (!values.amount) {
          errors.amount = 'Please Enter a Amount';
        }
        if (values.amount && !checkNumberOnly(replaceCommas(values.amount))) {
          errors.amount = 'Invalid Amount';
        }
        if (values.amount && checkNumberOnly(replaceCommas(values.amount)) && Number(replaceCommas(values.amount)) <= 0) {
          errors.amount = 'Amount cannot be zero or negative';
        }
        if (!values.transactionDate) {
          errors.transactionDate = 'Please Select a Date';
        }
      }
      if (action && (action.action == 'add_expense' || action.action == 'edit_expense')) {
        if (!values.amount) {
          errors.amount = 'Please Enter a Amount';
        }
        if (values.amount && !checkNumberOnly(replaceCommas(values.amount))) {
          errors.amount = 'Invalid Amount';
        }
        if (values.amount && checkNumberOnly(replaceCommas(values.amount)) && Number(replaceCommas(values.amount)) <= 0) {
          errors.amount = 'Amount cannot be zero or negative';
        }
        if ((!values.expense_type || !values.expense_type.value)) {
          errors.expense_type = 'Please Select a Expense';
        }
        if (!values.expenseDate) {
          errors.expenseDate = 'Please Select a Date';
        }
        if (!values.paymentMethod) {
          errors.paymentMethod = 'Please Select a Payment Mode';
        }
        if (values && values.paymentMethod && values.paymentMethod == 'credit' && !values.shop) {
          errors.shop = 'Please Select a shop.';
        }
        if (values && values.paymentMethod && values.paymentMethod == "paid_by_driver" && !values.selectedDriver) {
          errors.selectedDriver = "Please select the driver."
        }
        /*if (values.paidByDriver && !driverVal) {
          errors.paidByDriver = '';
        }*/
      }
      if (action &&
        (action.action == 'add_advance' || action.action == 'add_payment'
          || action.action == 'edit_party_advance'
          || action.action == 'edit_party_payment'
          || action.action == 'edit_vendor_advance'
          || action.action == 'edit_vendor_payment')) {
        if (!values.amount) {
          errors.amount = 'Please Enter a Amount';
        }
        if (values.amount && !checkNumberOnly(replaceCommas(values.amount)) && Number(replaceCommas(values.amount)) <= 0) {
          errors.amount = 'Invalid Amount';
        }
        if (values.amount && checkNumberOnly(replaceCommas(values.amount)) && Number(replaceCommas(values.amount)) <= 0) {
          errors.amount = 'Amount cannot be zero or negative';
        }
        if (person == "party" && values.amount && checkNumberOnly(replaceCommas(values.amount)) && Number(replaceCommas(values.amount)) > Number(partyBalance)) {
          errors.amount = `Amount cannot be greater than ${numberFormat(Number(partyBalance))}`;
        }
        if (person == "supplier" && values.amount && checkNumberOnly(replaceCommas(values.amount)) && Number(replaceCommas(values.amount)) > Number(vendorBalance)) {
          errors.amount = `Amount cannot be greater than ${numberFormat(Number(vendorBalance))}`;
        }
        if (!values.payment_mode) {
          errors.payment_mode = 'Please Select a Payment Method';
        }
        if (!values.date) {
          errors.date = 'Please Select a Date';
        }
      }
    } else {
      errors.noValues = "novalues"
    }
    return errors;
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    let personValue = action && action.tabs && action.tabs[newValue] && action.tabs[newValue].person ? action.tabs[newValue].person : 'party';
    setPerson(personValue);
    if (!defaultAmount && action.action == 'add_payment') {
      if (personValue && personValue == 'party' && partyBalance) {
        setPaymentAdvanceAmount(numberWithCommas(partyBalance))
      }
      if (personValue && personValue == 'supplier' && vendorBalance) {
        setPaymentAdvanceAmount(numberWithCommas(vendorBalance))
      }
    }
  };
  const handleFormSave = (e) => {
  }
  const handleClose = (status) => {
    onClose(false);
    setDialogOpen(false);
  };
  const onSubmit = async values => {
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));
    await sleep(300);
    //window.alert(JSON.stringify(values, 0, 2));
    if (action && action.action == 'edit_party_charge') {
      let { billing_type, chargeOrDeduction_type, transactionDate, amount, notes, id } = values;
      let request = {
        "amount": Number(replaceCommas(amount)),
        "description": notes ? notes : '',
        "expenseDate": transactionDate ? Math.round(new Date(transactionDate).setHours(0, 0, 0, 0) / 1000) : 0,
        "type": chargeOrDeduction_type && chargeOrDeduction_type.value ? chargeOrDeduction_type.value : ''
      }
      dispatchEditPartyCharges(tripId, id, request, (response) => {
        if (response && response.status && response.status && response.status.code && response.status.code === 200) {
          sendSucces(UPDATE_PARTY_CHARGE_SUCCESS);
          onUpdateSuccess(false);
        } else {
        }
      },
        () => {
        })
    }
    if (action && action.action == 'edit_vendor_charge') {
      let { billing_type, chargeOrDeduction_type, transactionDate, amount, notes, id } = values;
      let request = {
        "amount": Number(replaceCommas(amount)),
        "description": notes ? notes : '',
        "expenseDate": transactionDate ? Math.round(new Date(transactionDate).setHours(0, 0, 0, 0) / 1000) : 0,
        "type": chargeOrDeduction_type && chargeOrDeduction_type.value ? chargeOrDeduction_type.value : ''
      }
      request = {
        ...request,
        'fleetOwnerId': fleetOwnerId,
        "tripId": tripId,
        "vendorId": vendorId
      }
      dispatchEditVendorExpense(id, request, (response) => {
        if (response && response.status && response.status && response.status.code && response.status.code === 200) {
          sendSucces(UPDATE_VENDOR_CHARGE_SUCCESS);
          onUpdateSuccess(false);
        } else {
        }
      },
        () => {
        })
    }
    if (action && action.action == 'edit_vendor_reduction') {
      let { billing_type, chargeOrDeduction_type, transactionDate, amount, notes, id } = values;
      let request = {
        "amount": Number(replaceCommas(amount)),
        "description": notes ? notes : '',
        "expenseDate": transactionDate ? Math.round(new Date(transactionDate).setHours(0, 0, 0, 0) / 1000) : 0,
        "type": chargeOrDeduction_type && chargeOrDeduction_type.value ? chargeOrDeduction_type.value : ''
      }
      request = {
        ...request,
        'fleetOwnerId': fleetOwnerId,
        "tripId": tripId,
        "vendorId": vendorId
      }
      dispatchEditVendorDeduction(id, request, (response) => {
        if (response && response.status && response.status && response.status.code && response.status.code === 200) {
          sendSucces(UPDATE_VENDOR_DEDUCTION_SUCCESS);
          onUpdateSuccess(false);
        } else {
        }
      },
        () => {
        })
    }
    if (action && action.action == 'edit_party_reduction') {
      let { billing_type, chargeOrDeduction_type, transactionDate, amount, notes, id } = values;
      let request = {
        "amount": Number(replaceCommas(amount)),
        "description": notes ? notes : '',
        "expenseDate": transactionDate ? Math.round(new Date(transactionDate).setHours(0, 0, 0, 0) / 1000) : 0,
        "type": chargeOrDeduction_type && chargeOrDeduction_type.value ? chargeOrDeduction_type.value : ''
      }
      dispatchEditPartyDeductionAction(tripId, id, request, (response) => {
        if (response && response.status && response.status && response.status.code && response.status.code === 200) {
          sendSucces(UPDATE_PARTY_REDUCTION_SUCCESS);
          onUpdateSuccess(false);
        } else {
        }
      },
        () => {
        })
    }
    if (action && action.action == 'add_charges') {
      let { billing_type, chargeOrDeduction_type, transactionDate, amount, notes } = values;

      let deduction = billing_type && billing_type === 'reduce_from_bill' ? true : false;
      let request = {
        "amount": Number(replaceCommas(amount)),
        "description": notes ? notes : '',
        "expenseDate": transactionDate ? Math.round(new Date(transactionDate).setHours(0, 0, 0, 0) / 1000) : 0,
        "type": chargeOrDeduction_type && chargeOrDeduction_type.value ? chargeOrDeduction_type.value : ''
      }

      if (person == 'party') {
        if (deduction) {
          dispatchAddPartyDeductionAction(tripId, request, (response) => {
            if (response && response.status && response.status && response.status.code && response.status.code === 200) {
              trackTransactions('Dweb Trip Deduction Create');
              sendSucces(ADD_PARTY_DEDUCTION_SUCCESS);
              handleClose();
            } else {
              //sendError(response && response.status && response.status && response.status.message?response.status.message:ADD_PARTY_CHARGE_FAILURE)
            }
          },
            () => {
              //sendError(ADD_PARTY_DEDUCTION_FAILURE)
            })
        } else if (!deduction) {
          dispatchAddPartyChargeAction(tripId, request, (response) => {
            if (response && response.status && response.status && response.status.code && response.status.code === 200) {
              trackTransactions('Dweb Trip Charge Create');
              sendSucces(ADD_PARTY_CHARGE_SUCCESS);
              handleClose();
            } else {
              //sendError(response && response.status && response.status && response.status.message?response.status.message:ADD_PARTY_CHARGE_FAILURE)
            }
          },
            () => {
              //sendError(ADD_PARTY_CHARGE_FAILURE)
            })
        }
      } else if (person == 'supplier') {
        request = {
          ...request,
          'fleetOwnerId': fleetOwnerId,
          "tripId": tripId,
          "vendorId": vendorId
        }
        if (deduction) {
          dispatchAddVendorDeduction(request, (response) => {
            if (response && response.status && response.status && response.status.code && response.status.code === 200) {
              trackTransactions('Dweb Trip Supplier Deduction Create');
              sendSucces(ADD_VENDOR_DEDUCTION_SUCCESS);
              handleClose();
            } else {
              //sendError(response && response.status && response.status && response.status.message?response.status.message:ADD_VENDOR_DEDUCTION_FAILURE)
            }
          },
            () => {
              //sendError(ADD_VENDOR_DEDUCTION_FAILURE)
            })
        } else if (!deduction) {
          dispatchAddVendorExpense(request, (response) => {
            if (response && response.status && response.status && response.status.code && response.status.code === 200) {
              trackTransactions('Dweb Trip Expense Create');
              sendSucces(ADD_VENDOR_CHARGE_SUCCESS);
              handleClose();
            } else {
              //sendError(response && response.status && response.status && response.status.message?response.status.message:ADD_TRIP_EXPENS_FAILURE)
            }
          },
            () => {
              //sendError(ADD_TRIP_EXPENS_FAILURE)
            })
        }
      }
    }
    if (action && action.action == 'add_expense') {
      let { expense_type, paymentMethod, shop, expenseDate, amount, paidByDriver, description,
        addToPartyBill,
        partyBillableAmount,
        transactionId
      } = values;
      let request = {
        'fleetOwnerId': fleetOwnerId,
        "tripId": tripId,
        "amount": Number(replaceCommas(amount)),
        "description": description ? description : '',
        "expenseDate": expenseDate ? Math.round(new Date(expenseDate).setHours(0, 0, 0, 0) / 1000) : 0,
        "type": expense_type && expense_type.value ? expense_type.value : '',
        "paidByDriver": paidByDriver ? paidByDriver : false,
        "paymentMethod": paymentMethod,
        "vehicleId": vehicleId
      }
      if (addToPartyBill && partyBillableAmount) {
        request['billable'] = true;
        request['isBillable'] = true;
        request['billableAmount'] = Number(replaceCommas(partyBillableAmount));
      }
      if (paymentMethod && paymentMethod == 'online' && transactionId) {
        request['paymentData'] = transactionId;
      }
      if (paidByDriver && driverVal) {
        request['driverId'] = driverVal;
      } else if (paymentMethod && paymentMethod == 'paid_by_driver' && driverVal) {
        request['driverId'] = driverVal;
        request['paidByDriver'] = true
      } else {
        request['driverId'] = null;
        request['paidByDriver'] = false;
      }
      if (paymentMethod && paymentMethod == 'credit' && shop && shop.id) {
        request['shopId'] = shop.id;
      } else {
        request['shopId'] = null;
      }
      dispatchAddExpenseV1(request, (response) => {
        if (response && response.status && response.status && response.status.code && response.status.code === 200) {
          trackTransactions('Dweb Trip Expense Create');
          sendSucces(ADD_TRIP_EXPENS_SUCCESS);
          handleClose();
        } else {
          //sendError(response && response.status && response.status && response.status.message?response.status.message:ADD_TRIP_EXPENS_FAILURE)
        }
      },
        () => {
          //sendError(ADD_TRIP_EXPENS_FAILURE)
        })
    }
    if (action && action.action == 'edit_expense') {
      let { expense_type, expenseDate, paymentMethod, shop, amount, paidByDriver, description, id,
        addToPartyBill,
        partyBillableAmount,
        transactionId
      } = values;
      let request = {
        ...values,
        'fleetOwnerId': fleetOwnerId,
        "tripId": tripId,
        "amount": Number(replaceCommas(amount)),
        "description": description ? description : '',
        "expenseDate": expenseDate ? Math.round(new Date(expenseDate).setHours(0, 0, 0, 0) / 1000) : 0,
        "type": expense_type && expense_type.value ? expense_type.value : '',
        "paidByDriver": paidByDriver ? paidByDriver : false,
        "paymentMethod": paymentMethod,
        "vehicleId": vehicleId
      }
      if (addToPartyBill && partyBillableAmount) {
        request['billable'] = true;
        request['isBillable'] = true;
        request['billableAmount'] = Number(replaceCommas(partyBillableAmount));
      }
      if (paymentMethod && paymentMethod == 'online' && transactionId) {
        request['paymentData'] = transactionId;
      }
      if (paidByDriver && driverVal) {
        request['driverId'] = driverVal;
      } else if (paymentMethod && paymentMethod == 'paid_by_driver' && driverVal) {
        request['driverId'] = driverVal;
        request['paidByDriver'] = true
      } else {
        request['driverId'] = null;
        request['paidByDriver'] = false;
      }
      if (paymentMethod && paymentMethod == 'credit' && shop && shop.id) {
        request['shopId'] = shop.id;
      } else {
        request['shopId'] = null;
      }
      dispatchEditExpenseV1(id, request, (response) => {
        if (response && response.status && response.status && response.status.code && response.status.code === 200) {
          sendSucces(UPDATE_TRIP_EXPENSE_SUCCESS);
          onUpdateSuccess(false);
        } else {
        }
      },
        () => {
        })
    }
    if (action && action.action == 'edit_party_advance') {
      let { payment_mode, date, amount, receivedByDriver, notes, refNumber, id } = values;
      let request = {
        "amount": Number(replaceCommas(amount)),
        "description": notes ? notes : '',
        "paymentData": refNumber,
        "paymentDate": date ? Math.round(new Date(date).setHours(0, 0, 0, 0) / 1000) : 0,
        "paymentMode": payment_mode ? payment_mode : '',
        "receivedByDriver": receivedByDriver ? receivedByDriver : false,
      }
      if (receivedByDriver && driverVal) {
        request['driverId'] = driverVal;
      } else {
        request['driverId'] = null;
      }
      dispatchEditPartyAdvance(values.tripId ? values.tripId : tripId, id, request, (response) => {
        if (response && response.status && response.status && response.status.code && response.status.code === 200) {
          sendSucces(UPDATE_PARTY_ADVANCE_SUCCESS);
          onUpdateSuccess(false);
        } else {
        }
      },
        () => {
        })
    }
    if (action && action.action == 'edit_party_payment') {
      let { payment_mode, date, amount, receivedByDriver, notes, refNumber, id } = values;
      let request = {
        "amount": Number(replaceCommas(amount)),
        "description": notes ? notes : '',
        "paymentData": refNumber,
        "paymentDate": date ? Math.round(new Date(date).setHours(0, 0, 0, 0) / 1000) : 0,
        "paymentMode": payment_mode ? payment_mode : '',
        "receivedByDriver": receivedByDriver ? receivedByDriver : false,
      }
      if (receivedByDriver && driverVal) {
        request['driverId'] = driverVal;
      } else {
        request['driverId'] = null;
      }
      dispatchEditPartyPayment(tripId, id, request, (response) => {
        if (response && response.status && response.status && response.status.code && response.status.code === 200) {
          sendSucces(UPDATE_PARTY_PAYMENT_SUCCESS);
          onUpdateSuccess(false);
        } else {
        }
      },
        () => {
        })
    }
    if (action && action.action == 'edit_vendor_advance') {
      let { payment_mode, date, amount, receivedByDriver, notes, refNumber, id } = values;
      let request = {
        "amount": Number(replaceCommas(amount)),
        "description": notes ? notes : '',
        "paymentData": refNumber,
        "paymentDate": date ? Math.round(new Date(date).setHours(0, 0, 0, 0) / 1000) : 0,
        "paymentMode": payment_mode ? payment_mode : '',
        //"receivedByDriver":receivedByDriver?receivedByDriver:false,
      }
      request = {
        ...request,
        tripId: tripId,
        vendorId: vendorId,
        fleetOwnerId: fleetOwnerId,
      }
      dispatchEditVendorAdvance(id, request, (response) => {
        if (response && response.status && response.status && response.status.code && response.status.code === 200) {
          sendSucces(UPDATE_VENDOR_ADVANCE_SUCCESS);
          onUpdateSuccess(false);
        } else {
        }
      },
        () => {
        })
    }
    if (action && action.action == 'edit_vendor_payment') {
      let { payment_mode, date, amount, receivedByDriver, notes, refNumber, id } = values;
      let request = {
        "amount": Number(replaceCommas(amount)),
        "description": notes ? notes : '',
        "paymentData": refNumber,
        "paymentDate": date ? Math.round(new Date(date).setHours(0, 0, 0, 0) / 1000) : 0,
        "paymentMode": payment_mode ? payment_mode : '',
        //"receivedByDriver":receivedByDriver?receivedByDriver:false,
      }
      request = {
        ...request,
        tripId: tripId,
        vendorId: vendorId,
        fleetOwnerId: fleetOwnerId,
      }
      dispatchEditVendorPayment(id, request, (response) => {
        if (response && response.status && response.status && response.status.code && response.status.code === 200) {
          sendSucces(UPDATE_VENDOR_PAYMENT_SUCCESS);
          onUpdateSuccess(false);
        } else {
        }
      },
        () => {
        })
    }
    if (action && (action.action == 'add_advance' || action.action == 'add_payment')) {
      let { payment_mode, date, amount, receivedByDriver, notes, refNumber } = values;
      let request = {
        "amount": Number(replaceCommas(amount)),
        "description": notes ? notes : '',
        "paymentData": refNumber,
        "paymentDate": date ? Math.round(new Date(date).setHours(0, 0, 0, 0) / 1000) : 0,
        "paymentMode": payment_mode ? payment_mode : '',
      }
      if (person == 'party' && action.action == 'add_advance') {
        request['receivedByDriver'] = receivedByDriver;
        if (receivedByDriver && driverVal) {
          request['driverId'] = driverVal;
        } else {
          request['driverId'] = null;
        }
        dispatchAddPartyAdvanceAction(tripId, request, (response) => {
          if (response && response.status && response.status && response.status.code && response.status.code === 200) {
            trackTransactions('Dweb Trip Advance Create');
            sendSucces(ADD_PARTY_ADVANCE_SUCCESS);
            handleClose();
          } else {
            //sendError(response && response.status && response.status && response.status.message?response.status.message:ADD_PARTY_ADVANCE_FAILURE)
          }
        },
          () => {
            //sendError(ADD_PARTY_ADVANCE_FAILURE)
          })
      } else if (person == 'supplier' && action.action == 'add_advance') {
        request = {
          ...request,
          tripId: tripId,
          vendorId: vendorId,
          fleetOwnerId: fleetOwnerId,
        }
        dispatchAddVendorAdvanceAction(request, (response) => {
          if (response && response.status && response.status && response.status.code && response.status.code === 200) {
            trackTransactions('Dweb Trip Supplier Advance Create', vendorId);
            sendSucces(ADD_VENDOR_ADVANCE_SUCCESS);
            handleClose();
          } else {
            //sendError(response && response.status && response.status && response.status.message?response.status.message:ADD_VENDOR_ADVANCE_FAILURE)
          }
        },
          () => {
            //sendError(ADD_VENDOR_ADVANCE_FAILURE)
          })
      } else if (person == 'party' && action.action == 'add_payment') {
        request['receivedByDriver'] = receivedByDriver;
        if (receivedByDriver && driverVal) {
          request['driverId'] = driverVal;
        } else {
          request['driverId'] = null;
        }
        dispatchAddPartyPaymentAction(tripId, request, (response) => {
          if (response && response.status && response.status && response.status.code && response.status.code === 200) {
            trackTransactions('Dweb Trip Payment Create');
            sendSucces(ADD_PARTY_PAYMENT_SUCCESS);
            handleClose();
            trackDwebEvent("Dweb Party Payment Created", {
              party_id: tripDetails && tripDetails.party && tripDetails.party.id ? tripDetails.party.id : "",
              party_name: tripDetails && tripDetails.partyName ? tripDetails.partyName : "",
              party_balance: tripDetails && tripDetails.partyBalance ? tripDetails.partyBalance : "",
              payment_id: response && response.response && response.response.id? response.response.id:'',
              payment_amount: amount,
              payment_method: payment_mode ? payment_mode : "",

            });
          } else {
            trackDwebEvent("Dweb Party Payment Failed", {
              party_id: tripDetails && tripDetails.party && tripDetails.party.id ? tripDetails.party.id : "",
              party_name: tripDetails && tripDetails.partyName ? tripDetails.partyName : "",
              party_balance: tripDetails && tripDetails.partyBalance ? tripDetails.partyBalance : "",
              payment_id: response && response.response && response.response.id? response.response.id:'',
              payment_amount: amount,
              payment_method: payment_mode ? payment_mode : "",
              error_reason: response.status.message ? response.status.message : ""
            });
            //sendError(response && response.status && response.status && response.status.message?response.status.message:ADD_PARTY_PAYMENT_FAILURE)
          }
        },
          (response) => {
            trackDwebEvent("Dweb Party Payment Failed", {
              party_id: tripDetails && tripDetails.party && tripDetails.party.id ? tripDetails.party.id : "",
              party_name: tripDetails && tripDetails.partyName ? tripDetails.partyName : "",
              party_balance: tripDetails && tripDetails.partyBalance ? tripDetails.partyBalance : "",
              payment_id:response && response.response && response.response.id? response.response.id:'',
              payment_amount: amount,
              payment_method: payment_mode ? payment_mode : "",
              error_reason: response.status.message ? response.status.message : ""
            });
            //sendError(ADD_PARTY_PAYMENT_FAILURE)
          })
      } else if (person == 'supplier' && action.action == 'add_payment') {
        request = {
          ...request,
          tripId: tripId,
          vendorId: vendorId,
          fleetOwnerId: fleetOwnerId,
        }
        dispatchAddVendorPaymentAction(request, (response) => {
          if (response && response.status && response.status && response.status.code && response.status.code === 200) {
            trackTransactions('Dweb Trip Supplier Payment Create', vendorId);
            sendSucces(ADD_VENDOR_PAYMENT_SUCCESS);
            handleClose();
          } else {
            //sendError(response && response.status && response.status && response.status.message?response.status.message:ADD_VENDOR_PAYMENT_FAILURE)
          }
        },
          () => {
            //sendError(ADD_VENDOR_PAYMENT_FAILURE)
          })
      }
    }
  };

  const getFormFields = (values) => {
    /*if (values && values.receivedByDriver && !driverVal) {
      setDriverNameModalOpen(true);
    }*/
    if (action &&
      (action.action == 'add_charges' || action.action == 'edit_party_reduction'
        || action.action == 'edit_party_charge'
        || action.action == 'edit_vendor_charge'
        || action.action == 'edit_vendor_reduction')
    ) {
      let { billing_type } = values;
      let deduction = billing_type && billing_type === 'reduce_from_bill' ? true : false;
      setDeductionCheck(deduction);
      return [
        {
          size: 12,
          visible: action.action == 'add_charges' ? true : false,
          field: (
            <Radios
              label=""
              name="billing_type"
              formControlProps={{ margin: 'normal' }}
              radioGroupProps={{ row: true }}
              onChange={(e) => { setChargeOrDeductionBillingType(e.target.value) }}
              formControlLabelProps={{
                classes: {
                  root: inputClasses.formRadio
                }
              }}
              data={[
                { label: 'Add to Bill', value: 'add_to_bill' },
                { label: 'Reduce from Bill', value: 'reduce_from_bill' },
              ]}
            />
          ),
        },
        {
          size: 12,
          visible: true,
          field: (
            <>
              {/* {deductionTypeList && deductionTypeList.length > 0 && chargeTypeList && chargeTypeList.length > 0 && */}
              <Autocomplete
                id="select-chargeOrDeduction-type-list"
                name="chargeOrDeduction_type"
                size="small"
                classes={{
                  listbox: formClasses.listBoxAutoCompelete,
                  option: formClasses.listBoxOption,
                  popupIndicator: formClasses.popUpIndicator
                }}
                required={true}
                autoHighlight
                value={chargeOrDeductionType}
                onChange={(event, newValue) => {
                  if (typeof newValue === 'string') {
                    // timeout to avoid instant validation of the dialog's form.
                    setTimeout(() => {
                      setChargeOrDeductionType('');
                    });
                  } else if (newValue && newValue.inputValue) {
                    setChargeOrDeductionType(newValue);
                  } else if (newValue && newValue.inputValue === '') {
                    setChargeOrDeductionType('');
                  } else if (newValue && newValue.value) {
                    setChargeOrDeductionType(newValue && newValue.value ? newValue : null);
                  } else {
                    setChargeOrDeductionType('');
                  }
                }}
                filterOptions={(options, params) => {

                  const filtered = expenseTypefilter(options, params);

                  if (params.inputValue.trim().length > 0 && filtered && filtered.length == 0) {
                    filtered.unshift({
                      inputValue: params.inputValue,
                      display: params.inputValue && params.inputValue.length > 1 ? `Add "${params.inputValue}"` : ``,
                      add: true
                    });
                  }

                  return filtered;
                }}
                options={deduction ? deductionTypeList && deductionTypeList.length > 0 ? deductionTypeList : [] : chargeTypeList && chargeTypeList.length > 0 ? chargeTypeList : []}
                handleHomeEndKeys
                //groupBy={(option) => option.group}
                getOptionValue={option => option.value}
                getOptionLabel={(option) => {
                  // e.g value selected with enter, right from the input
                  if (typeof option === 'string') {
                    return '';
                  }
                  if (option.inputValue || !option.value) {
                    return '';
                  }
                  return option && option.display ? option.display : ''
                }}
                renderOption={(option, { selected, inputValue }) => {
                  let matchesName = match(option.display, inputValue);
                  let partsName = parse(option.display, matchesName);
                  if (option && option.display && !option.add) {
                    return (
                      <div className={formClasses.expenseTypeListItem}>
                        {partsName.map((part, index) => {
                          return (<span key={index} style={{ fontWeight: part.highlight ? 700 : 300, color: part.highlight ? '#00875a' : '#0b1323' }}>
                            {part.text}
                          </span>
                          )
                        })}
                      </div>
                    );

                  } else {
                    if (option && option.add && option.display) {
                      return (
                        <div className={formClasses.addExpenseListItem} onClick={() => handleAddCargeDeduction(deduction ? "deduction" : "charges")}>
                          <AddCircleOutlineIcon className={formClasses.addExpenseIcon} />
                          <span>{option.display}</span>
                          <ChevronRightIcon className={formClasses.cherveRightIcon} />
                        </div>
                      );
                    }
                  }
                }}
                textFieldProps={
                  {
                    label: deduction ? "Deduction Type" : "Charge Type",
                    placeholder: deduction ? "Select a Deduction Type" : "Select a Charge Type",
                    variant: "outlined",
                    margin: 'normal',
                    name: "chargeOrDeduction_type",
                  }
                }
                multiple={false}
              />
              {/* } */}
            </>
          ),
        },
        {
          size: 12,
          visible: true,
          field: (
            <AmountInput
              label={deduction ? 'Deduction Amount' : 'Charge Amount'}
              placeholder="Amount"
              name="amount"
              variant="outlined"
              size="small"
              margin="normal"
              onChange={(e) => {
                //numberWithCommasInput(e,setChargeOrDeductionAmount)
                setChargeOrDeductionAmount(e.target.value)
              }}
              fieldProps={{
                parse: value => value && numberWithCommas(value)
              }}
              InputProps={{
                startAdornment: <InputAdornment position="start">&#8377;</InputAdornment>
              }}
              required={true}
            />
          ),
        },
        {
          size: 12,
          visible: true,
          field: (
            <div>
              <DatePicker
                disableFuture
                name="transactionDate"
                margin="normal"
                variant="inline"
                inputVariant="outlined"
                size="small"
                format="dd-MM-yyyy"
                onChange={(date) => { setChargeOrDeductionDate(date) }}
                label={deduction ? 'Deduction Date' : 'Charge Date'}
                placeholder="Enter a Date"
                required={true}
                dateFunsUtils={DateFnsUtils}
                InputProps={{ endAdornment: <InputAdornment position="end"><EventOutlinedIcon className={formClasses.eventIcon}></EventOutlinedIcon></InputAdornment> }}
              />
            </div>
          ),
        },
        {
          size: 12,
          visible: true,
          field: (
            <TextField
              label={deduction ? 'Notes' : 'Notes'}
              placeholder="Enter Notes"
              name="notes"
              variant="outlined"
              size="small"
              margin="normal"
              multiline={true}
              onChange={(e) => { setChargeOrDeductionNotes(e.target.value) }}
              rows={3}
              rowsMax={3}
              InputProps={{
                startAdornment: <InputAdornment position="start"> <NotesIcon /></InputAdornment>
              }}
            />
          ),
        }
      ];
    } else if (action && (action.action == 'add_expense' || action.action == 'edit_expense')) {
      return [
        {
          size: 12,
          visible: (action.action == 'edit_expense' && values.expense_type && values.expense_type == 'Vehicle_Hire_Cost') ? false : true,
          field: (
            <Autocomplete
              id="select-expense-type-list"
              name="expense_type"
              size="small"
              classes={{
                listbox: formClasses.listBoxAutoCompelete,
                option: formClasses.listBoxOption
              }}
              required={true}
              autoHighlight
              value={expenseType}
              onChange={(event, newValue) => {

                if (newValue && newValue.value && newValue.value == "Fuel_Expense") {

                  setAddFuelExpenseOpen(true);

                } else if (typeof newValue === 'string') {
                  // timeout to avoid instant validation of the dialog's form.
                  setTimeout(() => {
                    setExpenseType('');
                    setNewExpenseOpen(true);
                    setNewExpenseType({
                      name: newValue ? newValue : "",
                    });
                  });
                } else if (newValue && newValue.inputValue) {
                  setExpenseType(null);
                  setNewExpenseOpen(true);
                  setNewExpenseType({
                    name: newValue.inputValue ? newValue.inputValue : "",
                  });
                } else if (newValue && newValue.inputValue === '') {
                  setExpenseType('');
                  setNewExpenseOpen(true);
                  setNewExpenseType({
                    name: "",
                  });
                } else {
                  setExpenseType(newValue && newValue.value ? newValue : null);
                }
              }}
              filterOptions={(options, params) => {
                const filtered = expenseTypefilter(options, params);
                if (params.inputValue && params.inputValue.length > 1) {
                  filtered.unshift({
                    inputValue: params.inputValue,
                    display: params.inputValue && params.inputValue.length > 1 ? `Add "${params.inputValue}"` : ``,
                    add: true
                  });
                }
                return filtered;
              }}
              options={trip && trip.tripExpenseTypes ? trip.tripExpenseTypes.filter((expense) => expense && expense.value && expense.value != 'Vehicle_Hire_Cost').sort(sortByDisplay) : []}
              handleHomeEndKeys
              //groupBy={(option) => option.group}
              getOptionValue={option => option.value}
              getOptionLabel={(option) => {
                // e.g value selected with enter, right from the input
                if (typeof option === 'string') {
                  return '';
                }
                if (option.inputValue || !option.value) {
                  return '';
                }
                return option && option.display ? option.display : ''
              }}
              renderOption={(option, { selected, inputValue }) => {
                let matchesName = match(option.display, inputValue);
                let partsName = parse(option.display, matchesName);
                if (option && option.display && !option.add) {
                  return (
                    <div className={formClasses.expenseTypeListItem}>
                      {partsName.map((part, index) => {
                        return (<span key={index} style={{ fontWeight: part.highlight ? 700 : 300, color: part.highlight ? '#00875a' : '#0b1323' }}>
                          {part.text}
                        </span>
                        )
                      })}
                    </div>
                  );

                } else {
                  return (
                    <div className={formClasses.addExpenseListItem}>
                      <AddCircleOutlineIcon className={formClasses.addExpenseIcon} />
                      <span>{option.display}</span>
                      <ChevronRightIcon className={formClasses.cherveRightIcon} />
                    </div>
                  );
                }
              }}
              textFieldProps={
                {
                  label: "Expense Type",
                  placeholder: "Select a Expense Type",
                  variant: "outlined",
                  margin: 'normal',
                  name: "expense_type",
                }
              }
              /*renderInput={(params) => (
                <TextField
                  {...params}
                  label="Expense Type"
                  placeholder="Select a Expense Type"
                  variant="outlined"
                  name="expense_type"
                  margin='normal'
                />
              )}*/
              multiple={false}
            />
          ),
        },
        {
          size: 12,
          visible: true,
          field: (
            <AmountInput
              label={'Expense Amount'}
              placeholder="Enter a Amount"
              name="amount"
              variant="outlined"
              size="small"
              onChange={(e) => {
                //numberWithCommasInput(e,setExpenseAmount)
                setExpenseAmount(e.target.value)
              }}
              fieldProps={{
                parse: value => value && numberWithCommas(value)
              }}
              InputProps={{
                startAdornment: <InputAdornment position="start">&#8377;</InputAdornment>
              }}
              margin="normal"
              required={true}
            />
          ),
        },
        {
          size: 12,
          visible: true,
          field: (
            <div>
              <DatePicker
                disableFuture
                name="expenseDate"
                margin="normal"
                variant="inline"
                inputVariant="outlined"
                size="small"
                onChange={(date) => { setExpenseDate(date) }}
                format="dd-MM-yyyy"
                label={'Expense Date'}
                placeholder="Enter a Date"
                required={true}
                dateFunsUtils={DateFnsUtils}
                InputProps={{ endAdornment: <InputAdornment position="end"><EventOutlinedIcon className={formClasses.eventIcon}></EventOutlinedIcon></InputAdornment> }}
              />
            </div>
          ),
        },
        {
          size: 12,
          visible: true,
          inline: false,
          field: (
            <>
              {/* <div className={formClasses.divTripV2}>Billing Information</div> */}
              <Radios
                label="Payment Mode"
                name="paymentMethod"
                required={true}
                formControlProps={{
                  margin: 'none',
                  className: formClasses.billingTypeRadio,
                  fullWidth: true
                }}
                formControlLabelProps={{
                  className: formClasses.billingTypeLabel
                }}
                className={formClasses.mtV2}
                onChange={(e) => { setExpensePaymentMethod(e.target.value) }}
                formLabelProps={{}}
                radioGroupProps={{ row: true }}
                data={hiredTrip ? [
                  { value: 'cash', label: 'Cash' },
                  { value: 'credit', label: 'Credit' },
                  { value: 'online', label: 'Online' }
                ] : [
                  { value: 'cash', label: 'Cash' },
                  { value: 'credit', label: 'Credit' },
                  { value: 'paid_by_driver', label: 'Paid By Driver' },
                  { value: 'online', label: 'Online' }
                ]}
              />
            </>
          ),
        },
        {
          size: 12,
          visible: values && values.paymentMethod && values.paymentMethod == 'credit' ? true : false,
          field: (<Autocomplete
            required={true}
            id="search-shop-input"
            onOpen={() => {
              fetchShops()
            }}
            // open={true}
            getOptionLabel={(option) => (typeof option === 'string' ? option : option.name)}
            options={shops}
            autoComplete
            name="shop"
            //includeInputInList
            filterSelectedOptions
            size="small"
            //disableClearable
            value={expenseShop}
            getOptionSelected={(option, value) => option.id === value.id}
            onChange={(event, newValue) => {
              if (typeof newValue === 'string') {
                // timeout to avoid instant validation of the dialog's form.
                setTimeout(() => {
                  setExpenseShop('');
                  toggleAddShopOpen(true);
                  setShopDialogValue({
                    name: newValue ? newValue : "",
                  });
                });
              } else if (newValue && newValue.inputValue) {
                setExpenseShop(null);
                toggleAddShopOpen(true);
                setShopDialogValue({
                  name: newValue.inputValue ? newValue.inputValue : "",
                });
              } else if (newValue && newValue.inputValue === '') {
                setExpenseShop('');
                toggleAddShopOpen(true);
                setShopDialogValue({
                  name: "",
                });
              } else {
                setExpenseShop(newValue && newValue.id ? newValue : null);
              }
            }}
            filterOptions={(options, params) => {
              let filtered = []
              options.forEach((item, index) => {
                filtered.push({
                  ...item,
                  index: index
                })
              });
              filtered.unshift({
                inputValue: params.inputValue,
                name: params.inputValue && params.inputValue.length > 1 ? `Add '${params.inputValue}' as shop` : `Add New Shop`,
                add: true
              });
              return filtered;
            }}
            clearOnBlur
            multiple={false}
            getOptionValue={option => option.id}
            getOptionLabel={(option) => {
              // e.g value selected with enter, right from the input
              if (typeof option === 'string') {
                return '';
              }
              if (option.inputValue || !option.id) {
                return '';
              }
              return option && option.name ? option.name : ''
            }}
            onInputChange={(event, newInputValue) => {
              setShopInputValue(newInputValue);
              onSearchBlur(newInputValue, false)
            }}
            classes={
              {
                option: formClasses.shopOption,
                listbox: formClasses.listBoxV1,
                paper: formClasses.autoCompletePaper
              }
            }
            textFieldProps={
              {
                label: "Shop",
                placeholder: "Search and select shop",
                variant: "outlined",
                margin: 'normal',
              }
            }
            //closeIcon={<ClearIcon className={classes.icon} />                }
            /*renderInput={(params) => (
                <TextField
                {...params} placeholder="Search and select shop"
                labelwidth={0}
                variant="outlined"
                fullWidth
                InputProps={{
                    ...params.InputProps,
                    type: 'search',
                    labelwidth:0,
                    endAdornment: <InputAdornment position="end">{(shopInputValue || value)?null:null}</InputAdornment>,
                }}
                />
            )}*/
            renderOption={(option, { selected, inputValue }) => {
              let matchesName, matchesNumber;
              let partsName, partsNumber;
              matchesName = match(option.name, inputValue);
              partsName = parse(option.name, matchesName);
              matchesNumber = match(option.contactNumber, inputValue);
              partsNumber = parse(option.contactNumber, matchesNumber);

              if (option && option.id) {
                if (option.index == shops.length - 1) {
                  return (
                    <Fragment>
                      <Waypoint
                        onEnter={() => {
                          if (!shopInputValue && shopsListData && shopsListData.maxPage && shopsListData.maxPage != currentPageNo) {
                            setCurrentPageNo(currentPageNo + 1)
                            fetchShops(data.inputValue, true)
                          }
                        }}
                      />
                      <div className={formClasses.shopListItem}>
                        {partsName.map((part, index) => {
                          return (<span key={index} style={{ fontWeight: part.highlight ? 300 : 'normal', color: part.highlight ? '#0033cc' : '#0b1323' }}>
                            {part.text}
                          </span>
                          )
                        })}
                        {option.contactNumber && <>
                          <FiberManualRecordIcon className={formClasses.titleBullet}></FiberManualRecordIcon>
                          {partsNumber.map((part, index) => {
                            return (<span key={index} style={{ fontWeight: part.highlight ? 300 : 'normal', color: part.highlight ? '#0033cc' : '#0b1323' }}>
                              {part.text ? (part.text).replace(/(\d{5})(\d{5})/, "$1-$2") : ""}
                            </span>
                            )
                          })}
                        </>}
                      </div>
                    </Fragment>
                  );
                } else {
                  return (
                    <div className={formClasses.shopListItem}>
                      {partsName.map((part, index) => {
                        return (<span key={index} style={{ fontWeight: part.highlight ? 300 : 'normal', color: part.highlight ? '#0033cc' : '#0b1323' }}>
                          {part.text}
                        </span>
                        )
                      })}
                      {option.contactNumber && <>
                        <FiberManualRecordIcon className={formClasses.titleBullet}></FiberManualRecordIcon>
                        {partsNumber.map((part, index) => {
                          return (<span key={index} style={{ fontWeight: part.highlight ? 300 : 'normal', color: part.highlight ? '#0033cc' : '#0b1323' }}>
                            {part.text ? (part.text).replace(/(\d{5})(\d{5})/, "$1-$2") : ""}
                          </span>
                          )
                        })}
                      </>}
                    </div>
                  );
                }
              } else {
                return (
                  <div className={formClasses.shopListItem1}>
                    <AddPersonIcon className={formClasses.addPersonIcon} />
                    {partsName.map((part, index) => {
                      return (<span key={index} style={{ color: index == 1 ? 'black' : '#5170f0' }}>
                        {part.text}
                      </span>
                      )
                    })}
                    <ChevronRightIcon className={formClasses.cherveRightIconV1} />
                  </div>
                );
              }

            }}
          />)
        },
        {
          size: 12,
          visible: values && values.paymentMethod && values.paymentMethod == 'online' ? true : false,
          field: (
            <TextField
              label={'Transaction ID'}
              placeholder="Transaction ID"
              name="transactionId"
              variant="outlined"
              size="small"
              margin="normal"
              onChange={(e) => { setExpenseTransactionId(e.target.value) }}
            />
          ),
        },
        {
          size: 12,
          visible: values && values.paymentMethod && values.paymentMethod == 'paid_by_driver' ? true : false,
          field: (
            <TextField
              label={'Driver'}
              placeholder="Driver"
              name="selectedDriver"
              variant="outlined"
              size="small"
              //value={tripDetails && tripDetails.driver && tripDetails.driver.name ? tripDetails.driver.name : null}
              disabled
              margin="normal"
            //onChange={(e) => { setExpenseTransactionId(e.target.value) }}
            />
          ),
        },
        {
          size: 12,
          visible: hiredTrip ? false : false,
          field: (<Switches
            size='small'
            margin='normal'
            fullWidth={true}
            formControlProps={{
              className: formClasses.switchControl
            }}
            onChange={(e, value) => {
              setExpensePaidByDriver(value)
              if (value && value && !driverVal) {
                handleDriverSelectOpen(true);
              }
            }}
            formGroupProps={{}}
            formControlLabelProps={{
              classes: {
                root: formClasses.switchLabel
              },
              labelPlacement: 'start',
            }}
            name="paidByDriver"
            data={{ label: 'Paid By Driver', value: true }} label="" />)
        },
        {
          size: 12,
          visible: false,
          field: (<Switches
            size='small'
            margin='normal'
            fullWidth={true}
            formControlProps={{
              className: formClasses.switchControl
            }}
            onChange={(e, value) => {
              setExpenseAddToPartyBill(value)
            }}
            formGroupProps={{}}
            formControlLabelProps={{
              classes: {
                root: formClasses.switchLabel
              },
              labelPlacement: 'start',
            }}
            name="addToPartyBill"
            data={{ label: 'Add To Party Bill', value: true }} label="" />)
        },
        {
          size: 12,
          visible: true,
          field: (<Checkboxes
            size='small'
            margin='normal'
            fullWidth={true}
            formControlProps={{
              className: formClasses.switchControl
            }}
            onChange={(e, value) => {
              setExpenseAddToPartyBill(value)
            }}
            formGroupProps={{}}
            formControlLabelProps={{
              classes: {
                root: formClasses.switchLabel
              },
              labelPlacement: 'end',
            }}
            name="addToPartyBill"
            data={{ label: 'Add To Party Bill', value: true }} label="" />)
        },
        {
          size: 12,
          visible: values && values.addToPartyBill ? true : false,
          field: (
            <AmountInput
              label={'Amount to be Added to Party Bill'}
              placeholder="Amount"
              name="partyBillableAmount"
              variant="outlined"
              size="small"
              onChange={(e) => {
                //numberWithCommasInput(e,setExpenseAmount)
                setExpenseBillableAmount(e.target.value)
              }}
              fieldProps={{
                parse: value => value && numberWithCommas(value)
              }}
              InputProps={{
                startAdornment: <InputAdornment position="start">&#8377;</InputAdornment>
              }}
              margin="normal"
              required={true}
            />
          ),
        },
        {
          size: 12,
          visible: true,
          field: (
            <TextField
              label={'Notes'}
              placeholder="Enter Notes"
              name="description"
              variant="outlined"
              size="small"
              margin="normal"
              onChange={(e) => { setExpenseNotes(e.target.value) }}
              multiline={true}
              rows={3}
              rowsMax={3}
              InputProps={{
                startAdornment: <InputAdornment position="start"> <NotesIcon /></InputAdornment>
              }}
            />
          ),
        }
      ]
    } else if (action &&
      (action.action == 'add_advance' || action.action == 'add_payment'
        || action.action == 'edit_party_advance' || action.action == 'edit_party_payment')
      || action.action == 'edit_vendor_advance' || action.action == 'edit_vendor_payment') {
      let tripSettlementMode = values.payment_mode;
      return [
        {
          size: 12,
          visible: true,
          field: (
            <AmountInput
              label={action.action == 'add_advance' ? 'Advance Amount' : 'Amount'}
              placeholder="Enter a Amount"
              name="amount"
              variant="outlined"
              size="small"
              onChange={(e) => {
                //numberWithCommasInput(e,setPaymentAdvanceAmount)
                setPaymentAdvanceAmount(e.target.value)
              }}
              fieldProps={{
                parse: value => value && numberWithCommas(value)
              }}
              InputProps={{
                startAdornment: <InputAdornment position="start">&#8377;</InputAdornment>
              }}
              margin="normal"
              required={true}
            />
          ),
        }, {
          size: 12,
          visible: true,
          field: (
            <Radios
              label=""
              required={true}
              name="payment_mode"
              formControlProps={{ margin: 'normal' }}
              radioGroupProps={{ row: true }}
              onChange={(e) => { setPaymentAdvanceMode(e.target.value) }}
              formControlLabelProps={{
                classes: {
                  root: inputClasses.formRadio
                }
              }}
              data={[
                { value: "Cash", label: "Cash" },
                { value: "Cheque", label: "Cheque" },
                { value: "UPI", label: "UPI" },
                { value: "Bank Transfer", label: "Bank Transfer" },
                { value: "Fuel", label: "Fuel" },
                { value: "Others", label: "Others" },
              ]}
            />
          ),
        },
        {
          size: 12,
          visible: ['Cheque', 'UPI', 'Bank Transfer'].includes(tripSettlementMode),
          field: (
            <TextField
              label={(tripSettlementMode === 'Cheque' ? 'Cheque' : 'Reference') + " Number"}
              placeholder={"Enter a " + (tripSettlementMode === 'Cheque' ? 'Cheque' : 'Reference') + " Number"}
              name="refNumber"
              variant="outlined"
              onChange={(e) => { setPaymentAdvanceRefNum(e.target.value) }}
              size="small"
              fieldProps={
                {

                }
              }
              margin="normal"
            />
          ),
        },
        {
          size: 12,
          visible: true,
          field: (
            <div>
              <DatePicker
                disableFuture
                name="date"
                margin="normal"
                variant="inline"
                inputVariant="outlined"
                size="small"
                onChange={(date) => { setPaymentAdvanceDate(date) }}
                format="dd-MM-yyyy"
                label={'Payment Date'}
                placeholder="Enter a Date"
                required={true}
                dateFunsUtils={DateFnsUtils}
                InputProps={{ endAdornment: <InputAdornment position="end"><EventOutlinedIcon className={formClasses.eventIcon}></EventOutlinedIcon></InputAdornment> }}
              />
            </div>
          ),
        },
        {
          size: 12,
          visible: !hiredTrip ? true : false,
          field: (<div>
            <Switches
              size='small'
              margin='normal'
              formControlProps={{
                className: formClasses.switchControl
              }}
              formGroupProps={{}}
              formControlLabelProps={{
                classes: {
                  root: formClasses.switchLabel
                },
                labelPlacement: 'start',
              }}
              name="receivedByDriver"
              onChange={(e, value) => {
                setPaymentAdvanceReceivedByDriver(value)
                if (value && value && !driverVal) {
                  handleDriverSelectOpen(true);
                }
              }}
              data={{ label: 'Received By Driver', value: true }} label="" />
            {/* <OnChange name="receivedByDriver">
                    {(value, previous) => {
                      // do something
                      if (value && !driverVal) {
                        handleDriverSelectOpen(true);
                      }
                    }}
                  </OnChange> */}
          </div>)
        },
        {
          size: 12,
          visible: true,
          field: (
            <TextField
              label={'Notes'}
              placeholder="Enter Notes"
              name="notes"
              variant="outlined"
              size="small"
              margin="normal"
              onChange={(e) => { setPaymentAdvanceNotes(e.target.value) }}
              multiline={true}
              rows={3}
              rowsMax={3}
              InputProps={{
                startAdornment: <InputAdornment position="start"> <NotesIcon /></InputAdornment>
              }}
            />
          ),
        }
      ]
    }
    return [];
  }
  let initialValues = {};
  if (action && action.action == 'add_charges') {
    initialValues = {
      ...initialValues,
      billing_type: chargeOrDeductionBillingType,
      transactionDate: chargeOrDeductionDate,
      chargeOrDeduction_type: chargeOrDeductionType,
      notes: chargeOrDeductionNotes,
      amount: chargeOrDeductionAmount
    }
  }
  if (action && (action.action == 'edit_party_charge')) {
    initialValues = {
      ...initialValues,
      ...editData,
      billing_type: chargeOrDeductionBillingType,
      transactionDate: chargeOrDeductionDate,
      chargeOrDeduction_type: chargeOrDeductionType,
      notes: chargeOrDeductionNotes,
      amount: chargeOrDeductionAmount
    }
  }
  if (action && (action.action == 'edit_vendor_charge')) {
    initialValues = {
      ...initialValues,
      ...editData,
      billing_type: chargeOrDeductionBillingType,
      transactionDate: chargeOrDeductionDate,
      chargeOrDeduction_type: chargeOrDeductionType,
      notes: chargeOrDeductionNotes,
      amount: chargeOrDeductionAmount
    }
  }
  if (action && (action.action == 'edit_vendor_reduction')) {
    initialValues = {
      ...initialValues,
      ...editData,
      billing_type: chargeOrDeductionBillingType,
      transactionDate: chargeOrDeductionDate,
      chargeOrDeduction_type: chargeOrDeductionType,
      notes: chargeOrDeductionNotes,
      amount: chargeOrDeductionAmount
    }
  }
  if (action && (action.action == 'edit_party_reduction')) {
    initialValues = {
      ...initialValues,
      ...editData,
      billing_type: chargeOrDeductionBillingType,
      transactionDate: chargeOrDeductionDate,
      chargeOrDeduction_type: chargeOrDeductionType,
      notes: chargeOrDeductionNotes,
      amount: chargeOrDeductionAmount
    }
  }
  if (action && action.action == 'add_expense') {
    initialValues = {
      ...initialValues,
      expenseDate: expenseDate,
      amount: expenseAmount,
      expense_type: expenseType,
      description: expenseNotes,
      paidByDriver: expensePaidByDriver,
      paymentMethod: expensePaymentMethod,
      shop: expenseShop,
      addToPartyBill: expenseAddToPartyBill,
      partyBillableAmount: expenseBillableAmount,
      transactionId: expenseTransactionId,
      selectedDriver: selectedExpenseDriver
    }
  }
  if (action && action.action == 'edit_expense') {
    initialValues = {
      ...initialValues,
      ...editData,
      expenseDate: expenseDate,
      amount: expenseAmount,
      expense_type: expenseType,
      description: expenseNotes,
      paidByDriver: expensePaidByDriver,
      paymentMethod: expensePaymentMethod,
      shop: expenseShop,
      addToPartyBill: expenseAddToPartyBill,
      partyBillableAmount: expenseBillableAmount,
      transactionId: expenseTransactionId,
      selectedDriver: selectedExpenseDriver
    }
  }
  if (action && (action.action == 'add_advance' || action.action == 'add_payment')) {
    initialValues = {
      ...initialValues,
      payment_mode: paymentAdvanceMode,
      amount: paymentAdvanceAmount,
      date: paymentAdvanceDate,
      notes: paymentAdvanceNotes,
      refNumber: paymentAdvanceRefNum,
      receivedByDriver: paymentAdvanceReceivedByDriver
    }
    /*if(!defaultAmount && action.action=='add_payment'){
      if (person && person == 'party' && partyBalance) {
        initialValues['amount'] = numberWithCommas(partyBalance)
      }
      if (person && person == 'supplier' && vendorBalance) {
        initialValues['amount'] = numberWithCommas(vendorBalance)
      }
    }*/
  }
  if (action && (action.action == 'edit_party_advance' || action.action == 'edit_party_payment')) {
    initialValues = {
      ...initialValues,
      ...editData,
      payment_mode: paymentAdvanceMode,
      amount: paymentAdvanceAmount,
      date: paymentAdvanceDate,
      notes: paymentAdvanceNotes,
      refNumber: paymentAdvanceRefNum,
      receivedByDriver: paymentAdvanceReceivedByDriver
    }
  }
  if (action && (action.action == 'edit_vendor_advance' || action.action == 'edit_vendor_payment')) {
    initialValues = {
      ...initialValues,
      ...editData,
      payment_mode: paymentAdvanceMode,
      amount: paymentAdvanceAmount,
      date: paymentAdvanceDate,
      notes: paymentAdvanceNotes,
      refNumber: paymentAdvanceRefNum
    }
  }

  const handleAddCargeDeduction = (type) => {
    setAddChargeDeduction(true);
    setCheckType(type);
  }

  const handleAddChargeDeductionClose = () => {
    setChargeOrDeductionType("");
    setAddChargeDeduction(false);
    setCheckType("");
  }

  const handleAddChargeDeductionSave = (response) => {
    setChargeOrDeductionType(response);
    setAddChargeDeduction(false);
    setCheckType("");
  }

  const handleAddFuelExpenseClose = () => {
    setAddFuelExpenseOpen(false);
    onClose(false);
  }

  return (
    <div>
      <Dialog
        fullWidth={true}
        maxWidth='xs'
        onClose={handleClose}
        disableEscapeKeyDown={true}
        disableBackdropClick={true}
        aria-labelledby={"trip-actions-title-for-" + action && action.action ? action.action : ''}
        open={dialogopen}
      >
        <DialogTitle id={"trip-actions-title-for-" + action && action.action ? action.action : ''} onClose={handleClose}>
          {action && action.label ? action.label : 'Trip Actions'}
        </DialogTitle>
        <TripActionDialogContent dividers>
          <Form
            onSubmit={onSubmit}
            initialValues={initialValues}
            validate={validate}
            render={({ handleSubmit, form, submitting, pristine, values }) => {
              submit = handleSubmit;
              setFormError(isEmpty(validate(values)))
              return (
                <form onSubmit={handleSubmit} noValidate>
                  {action && action.tabsFormat && <TransportBookTabs value={value} onChange={(e, value) => { form.reset(); handleChange(e, value) }} aria-label="Page Tabs">
                    {action && action.tabs && action.tabs.map((item, index) => {
                      return (item && item.visible ? <AntTab disabled={item.disabled} key={index} label={item.name} {...a11yProps(index)} /> : null);
                    })}
                  </TransportBookTabs>}
                  {action && action.tabsFormat && action.tabs && action.tabs.map((item, index) => {
                    return (item && item.visible ?
                      <TabPanel key={index} value={value} index={index}>
                        <Grid container alignItems="flex-start" spacing={0}>
                          {getFormFields(values).map((item, idx) => item.visible ? (
                            <Grid item xs={item.size} key={idx}>
                              {item.field}
                            </Grid>
                          ) : null)}
                        </Grid>
                      </TabPanel> : null);
                  })}
                  {action && !action.tabsFormat &&
                    <Grid container alignItems="flex-start" spacing={0}>
                      {getFormFields(values).map((item, idx) => item.visible ? (
                        <Grid item xs={item.size} key={idx}>
                          {item.field}
                        </Grid>
                      ) : null)}
                    </Grid>
                  }
                </form>
              )
            }}
          />
        </TripActionDialogContent>
        <DialogActions>
          <Button variant="contained" className='modal-close-cta' onClick={handleClose} style={{ marginRight: 16 }} >
            Close
          </Button>
          <Button variant="contained"
            type="submit"
            //className='modal-save-cta'
            // className={!formError ? formClasses.disableCta : formClasses.saveCta}
            // disabled={!formError}
            className={formClasses.saveCta}
            onClick={event => submit(event)} >
            {confirmText ? confirmText : 'Confirm'}
          </Button>
        </DialogActions>
      </Dialog>
      {addChargeDeduction && <AddChargeDeductionType open={addChargeDeduction} defaultName={chargeOrDeductionType && chargeOrDeductionType.inputValue ? chargeOrDeductionType.inputValue : ""} onClose={handleAddChargeDeductionClose} onSave={handleAddChargeDeductionSave} typeValue={checkType} />}
      {newExpenseOpen && <AddExpenseType open={newExpenseOpen} defaultName={newExpenseType.name} onClose={handleAddExpenseTypeClose} onSave={handleAddExpenseTypeSave} />}
      {driverNameModalOpen && <DriverSelect onOpen={driverNameModalOpen} onClose={handleDriverSelectClose} onConfirm={handleDriverSelectConfirm} />}
      {addShopOpen && <AddShop open={addShopOpen} defaultName={shopDialogValue.name} defaultNumber={shopDialogValue.number} onClose={handleAddShopClose} onSave={handleShopSave} />}
      {addFuelExpenseOpen && <AddFuelExpenseDialog open={addFuelExpenseOpen} onClose={handleAddFuelExpenseClose} onConfirm={handleAddFuelExpenseClose} requestData={addFuelExpenseData} fromSingleTrip={true} />}
    </div>
  );
}

// fuelExpenseData={singleExpenseDetails} edit={editExpenseDialog} expenseId={expenseIdValue}

const TripActionDialogWithRouter = withRouter(TripActionDialog);
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
  dispatchAddPartyChargeAction: (tripId, data, onSuccess, onError) => dispatch(addPartyCharge(tripId, data, onSuccess, onError)),
  dispatchAddPartyAdvanceAction: (tripId, data, onSuccess, onError) => dispatch(addPartyAdvance(tripId, data, onSuccess, onError)),
  dispatchAddVendorAdvanceAction: (data, onSuccess, onError) => dispatch(addVendorAdvance(data, onSuccess, onError)),
  dispatchAddPartyPaymentAction: (tripId, data, onSuccess, onError) => dispatch(addPartyPayment(tripId, data, onSuccess, onError)),
  dispatchAddVendorPaymentAction: (data, onSuccess, onError) => dispatch(addVendorPayment(data, onSuccess, onError)),
  dispatchAddPartyExpenseAction: (tripId, data, onSuccess, onError) => dispatch(addPartyExpense(tripId, data, onSuccess, onError)),
  dispatchAddPartyDeductionAction: (tripId, data, onSuccess, onError) => dispatch(addPartyDeduction(tripId, data, onSuccess, onError)),
  dispatchEditPartyDeductionAction: (tripId, deductionId, data, onSuccess, onError) => dispatch(editPartyDeduction(tripId, deductionId, data, onSuccess, onError)),
  dispatchAddVendorExpense: (request, onSuccess, onFailure) =>
    dispatch(addVendorExpense(request, onSuccess, onFailure)),
  dispatchAddExpenseV1: (request, onSuccess, onFailure) =>
    dispatch(addExpenseV1(request, onSuccess, onFailure)),
  dispatchAddVendorDeduction: (request, onSuccess, onFailure) =>
    dispatch(addVendorDeduction(request, onSuccess, onFailure)),
  dispatchEditVendorExpense: (expenseId, request, onSuccess, onFailure) =>
    dispatch(editVendorExpense(expenseId, request, onSuccess, onFailure)),
  dispatchEditExpenseV1: (expenseId, request, onSuccess, onFailure) =>
    dispatch(editExpenseV1(expenseId, request, onSuccess, onFailure)),
  dispatchEditPartyCharges: (tripId, chargeId, request, onSuccess, onFailure) =>
    dispatch(editPartyCharge(tripId, chargeId, request, onSuccess, onFailure)),
  dispatchEditPartyAdvance: (tripId, advanceId, request, onSuccess, onFailure) => dispatch(editPartyAdvance(tripId, advanceId, request, onSuccess, onFailure)),
  dispatchEditPartyPayment: (tripId, paymentId, request, onSuccess, onFailure) => dispatch(editPartyPayment(tripId, paymentId, request, onSuccess, onFailure)),
  dispatchEditVendorDeduction: (deductionId, request, onSuccess, onFailure) => dispatch(editVendorDeduction(deductionId, request, onSuccess, onFailure)),
  dispatchEditVendorAdvance: (advanceId, request, onSuccess, onFailure) => dispatch(editVendorAdvance(advanceId, request, onSuccess, onFailure)),
  dispatchEditVendorPayment: (paymentId, request, onSuccess, onFailure) => dispatch(editVendorPayment(paymentId, request, onSuccess, onFailure)),
  dispatchGetTripExpenseTypes: (onSuccess, onFailure) => dispatch(tripExpenseTypes(onSuccess, onFailure)),
  dispatchGetAllDrivers: (onSuccess, onFailure) => dispatch(getAllDrivers(null, onSuccess, onFailure)),
  dispatchUpdateTrip: (tripId, trip, onSuccess, onError) => {
    dispatch(updateTrip(tripId, trip, onSuccess, onError));
  },
  dispatchGetCharges: (onSuccess, onError) => {
    dispatch(getChargeTypes(onSuccess, onError))
  },
  dispatchGetDeductions: (onSuccess, onError) => {
    dispatch(getDeductionTypes(onSuccess, onError))
  },
  dispatchGetShopList: (data, onSuccess, onError) => {
    dispatch(shopListForSelection(data, onSuccess, onError))
  },
  dispatchTripDetailsAction: (tripId, onSuccess, onError) =>
    dispatch(getTripDetailsV3(tripId, onSuccess, onError)),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TripActionDialogWithRouter);
